export default "__VITE_ASSET__BvZ8S_Wv__"